// extracted by mini-css-extract-plugin
export const action = "CloseButton__action__mfQfQ";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const closeButton = "CloseButton__closeButton__3r25Z";
export const danger = "CloseButton__danger__BBwy-";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const light = "CloseButton__light__JlNSe";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const small = "CloseButton__small__qSI62";
export const success = "CloseButton__success__ssbk1";
export const warning = "CloseButton__warning__liBeD";